import React from 'react'
import styles from './StyleguideFrame.scss'
import {StandardLayout} from 'common/layouts/StandardLayout'
import {base} from 'lib/styleguide/base.scss'
import {Link, IndexLink} from 'react-router'
import cx from 'classnames'

export class StyleguideFrame extends React.PureComponent {
  render () {
    const {children} = this.props
    return (
      <StandardLayout>
        <div className={cx(styles.StyleguideFrame, base)}>
          <div className={styles.body}>
            <Nav />
            <div className={styles.content}>
              {children}
            </div>
          </div>
        </div>
      </StandardLayout>
    )
  }
}

const NavLink = (props) => <Link {...props}
  className={styles.navItem}
  activeClassName={styles.active} />

const IndexNavLink = (props) => <IndexLink {...props}
  className={styles.navItem}
  activeClassName={styles.active} />

const Nav = () => (
  <div className={styles.navigation}>
    <IndexNavLink to='/styleguide'>Typography</IndexNavLink>
    <NavLink to='/styleguide/colors'>Colors</NavLink>
    <NavLink to='/styleguide/buttons'>Buttons</NavLink>
    <NavLink to='/styleguide/lists'>Lists</NavLink>
    <NavLink to='/styleguide/modals'>Modals</NavLink>
    <NavLink to='/styleguide/popovers'>Popovers</NavLink>
    <NavLink to='/styleguide/tooltips'>Tooltips</NavLink>
    <NavLink to='/styleguide/hero_component'>Hero Component</NavLink>
    <NavLink to='/styleguide/login'>Login</NavLink>
    <NavLink to='/styleguide/navbar'>Navigation</NavLink>
    <NavLink to='/styleguide/forms'>Forms</NavLink>
    <NavLink to='/styleguide/widgets'>Widgets</NavLink>
    <NavLink to='/styleguide/icons'>Icons</NavLink>
    <NavLink to='/styleguide/units'>Units</NavLink>
  </div>
)
